import React, { useEffect, useState } from "react";
import "./HighScores.css";
import { useFirebase } from "../contexts/FirebaseContext";
import { useLanguage } from "../contexts/LanguageContext";

const formatTime = (sec) => {
  if (typeof sec !== "number") return "";
  const total = Math.max(0, Math.floor(sec));
  const mins = Math.floor(total / 60);
  const secs = total % 60;
  return `${mins}:${String(secs).padStart(2, "0")}`;
};

const SolitaireHighScores = ({ currentTimeSec, currentMoves, inline = true }) => {
  const { getSolitaireHighScores, userId } = useFirebase();
  const { t } = useLanguage();
  const [scores, setScores] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const load = async () => {
      setLoading(true);
      try {
        const list = await getSolitaireHighScores(10);
        setScores(list.slice(0, 10));
      } catch (error) {
        console.error(error);
      } finally {
        setLoading(false);
      }
    };
    load();
  }, [getSolitaireHighScores, currentTimeSec]);

  const containerClass = inline ? "high-scores-inline" : "high-scores-container";
  const cardClass = inline
    ? "high-scores-card high-scores-inline-card"
    : "high-scores-card";

  return (
    <div className={containerClass}>
      <div className={cardClass}>
        <h2 className="high-scores-title">{t("highScores")}</h2>

        {currentTimeSec != null && (
          <div className="current-score-display">
            <p className="current-score-label">{t("yourScore")}</p>
            <p className="current-score-value">{formatTime(currentTimeSec)}</p>
            <p className="current-score-rank">
              {t("moves")}: {currentMoves}
            </p>
          </div>
        )}

        {loading ? (
          <div className="high-scores-loading">{t("loading")}</div>
        ) : scores.length === 0 ? (
          <div className="high-scores-empty">{t("noHighScores")}</div>
        ) : (
          <div className="high-scores-list">
            {scores.map((score, index) => (
              <div
                key={score.id}
                className={`high-score-item ${
                  score.userId && userId && score.userId === userId
                    ? "current-user-score"
                    : ""
                }`}
              >
                <div className="high-score-rank">#{index + 1}</div>
                <div className="high-score-name">
                  {score.displayName || t("anonymous")}
                </div>
                <div className="high-score-value">
                  {formatTime(score.timeSec)} · {t("moves")} {score.moves ?? "—"}
                </div>
                <div className="high-score-date">
                  {score.timestamp?.toDate
                    ? score.timestamp.toDate().toLocaleDateString()
                    : ""}
                </div>
              </div>
            ))}
          </div>
        )}
      </div>
    </div>
  );
};

export default SolitaireHighScores;
